import { Empty } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const Forbidden = () => {
  const { t } = useTranslation();
  return <Empty description={t(`You don't have permissions to explore the page.`)} />;
};
